import { render, staticRenderFns } from "./coupon-popup.vue?vue&type=template&id=96e49af6&scoped=true&"
import script from "./coupon-popup.vue?vue&type=script&lang=js&"
export * from "./coupon-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e49af6",
  null
  
)

export default component.exports